import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useMoveJob = () => {
  const { t } = useTranslation();

  const { showSuccess, showError } = useNotifications();

  const trpcContext = trpc.useUtils();

  const { mutateAsync: moveJob, isLoading: moveJobIsLoading } =
    trpc.moveJob.useMutation({
      onSuccess: async (order) => {
        showSuccess(
          t('common.notification.success.message', {
            action: 'moved',
            entity: 'booking',
          })
        );
        await trpcContext.serviceLocation.getLocationLinkedTechnicianUsers.invalidate();
        await trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();
        await trpcContext.getConflictLanes.invalidate();
        await trpcContext.orders.getOrder.invalidate({ id: order.orderId });
      },
      onError: async () => {
        showError(
          t('common.notification.error.message', {
            action: 'move',
            entity: 'booking',
          })
        );
        await trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();
      },
    });

  return { moveJob, moveJobIsLoading };
};
